import React, { useContext, useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { ProgressSpinner } from "primereact/progressspinner";
import {
  genElText,
  genElTextPassword,
} from "../components/utils/EditorDialogElementGenerator";
import useAPIRequest from "../custom_hooks/simple/useAPIRequest";
import { useSelector } from "react-redux";
import UiContext from "../store/ui-context";

const editTitle = "Edit Profile";

const EditProfileDialog = (props) => {
  const user = useSelector((state) => state.auth.user);
  const uiContext = useContext(UiContext);

  const {
    visible,
    onHide,
    // onConfirm,
    // loading,
    // title,
    // data,
    // setData,
    // addNewMode,
    // error,
    // setError,
  } = props;

  const { requestGet, requestGetOne, requestPost, requestDelete, loading } =
    useAPIRequest();

  const [data, setData] = useState({});
  const [error, setError] = useState({});

  // useeffect section

  useEffect(() => {
    if (visible) {
      if (user) {
        setData({
          name: user.name,
          username: user.username,
          email: user.email,
          password: "",
          cpassword: "",
        });
        setError({});
      }
    }
  }, [visible]);

  /**
   * Validates the form data.
   *
   * @returns {boolean} - Returns true if the data is valid, otherwise false.
   * @returns {object} - Returns an object containing the error messages, format { field: message}.
   */
  const validate = () => {
    let valid = true;
    let newEror = {};

    const name = data.name ? data.name.trim() : data.name;
    if (name === "" || name === null || name === undefined) {
      newEror = { ...newEror, name: "Nama harus diisi" };
      valid = false;
    }

    const username = data.username ? data.username.trim() : data.username;
    if (username === "" || username === null || username === undefined) {
      newEror = { ...newEror, username: "Username harus diisi" };
      valid = false;
    }

    const email = data.email ? data.email.trim() : data.email;
    if (email === "" || email === null || email === undefined) {
      newEror = { ...newEror, email: "Email harus diisi" };
      valid = false;
    }

    const password = data.password;
    const cpassword = data.cpassword;

    if (password || cpassword) {
      if (password !== cpassword) {
        newEror = {
          ...newEror,
          password: "Password & Konfirmasi tidak sama",
          cpassword: "Password & Konfirmasi tidak sama",
        };
        valid = false;
      }
    }

    if (!valid) setError(newEror);

    return valid;
  };

  // API call section

  const saveProfile = async (data) => {
    // refine save body
    const _body = data;

    // console.log("SAVE PRODUK", _produk);

    return requestPost({
      fullUrl: `/api/user/editprofile`,
      body: _body,
      onSuccess: ({ pagination, message, data }) => {
        uiContext.showSuccessMsg("Success", message);
        onHide();
      },
      onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
    });
  };

  // other function section
  const reformatSaveData = (data) => {
    return {
      ...data,
    };
  };

  // handle UI event section

  const handleOnClickConfirm = async (data) => {
    const body = reformatSaveData(data);
    saveProfile(body);
  };

  /**
   * Generate Dialog Form Element
   *
   * various function to generate
   *
   * genElText({ field, name, data, setData, disabled, autoFocus, error })
   * genElTextPassword({ field, name, data, setData, disabled, autoFocus, error })
   * genElTextDropdown({ field, name, data, setData, options, disabled, autoFocus, error, optionLabel = "name" })
   * genElNumber({ field, name, data, setData, min_fraction_digits, max_fraction_digits, min, max, disabled, autoFocus, error })
   * genElNumberDropdown({ field, name, data, setData, options, disabled, autoFocus, error, optionLabel = "name" })
   * genElBoolean({ field, name, data, setData, labelTrue = "Ya", labelFalse = "Tidak", disabled, autoFocus, error })
   * genElDate({ field, name, data, setData, primeFormat, min, max, showTime, time, month, year, disabled, autoFocus, error })
   * genElObject({ field, name, value, onClick, selectorGenerator, disabled, autoFocus, error })
   */

  const elNama = genElText({
    field: "name",
    name: "Nama",
    data,
    setData,
    error,
  });
  const elUsername = genElText({
    field: "username",
    name: "Username",
    data,
    setData,
    error,
  });
  const elEmail = genElText({
    field: "email",
    name: "Email",
    data,
    setData,
    error,
  });
  const elPassword = genElTextPassword({
    field: "password",
    name: "Password",
    data,
    setData,
    error,
  });
  const elConfirmPassword = genElTextPassword({
    field: "cpassword",
    name: "Konfirmasi Password",
    data,
    setData,
    error,
  });

  const dialogFooter = (
    <React.Fragment>
      <Button
        label="Cancel"
        icon="pi pi-times"
        outlined
        onClick={props.onHide}
      />
      <Button
        label="Save"
        icon="pi pi-check"
        onClick={(e) => {
          const valid = validate();
          if (valid) {
            handleOnClickConfirm(data);
          }
        }}
      />
    </React.Fragment>
  );

  return (
    <Dialog
      visible={visible}
      style={{ width: "25rem" }}
      // breakpoints={{ "960px": "75vw", "641px": "90vw" }}
      header={editTitle}
      modal
      className={`p-fluid`}
      footer={dialogFooter}
      onHide={onHide}
    >
      <div className="col-start-center relative h-100">
        <div className={`row-start-start w-100 gap-3`}>
          <div className="col-start-start w-100 gap-3">
            {elNama}
            {elUsername}
            {elEmail}
            {elPassword}
            {elConfirmPassword}
          </div>
        </div>
        {loading && (
          <div
            className={`col-center-center w-100  gap-2 absolute z-100 h-100 bg-black/20 rounded `}
          >
            <ProgressSpinner />
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default EditProfileDialog;
